<mat-nav-list>
    <ng-container *ngFor="let option of data; let index = index">
        <mat-list-item (click)="select(option)" (keyup.enter)="select(option)" tabindex="0">
            <mat-icon class="dark-accent">{{ option.icon }}</mat-icon>
            <span mat-line>{{ option.label }}</span>
        </mat-list-item>
        <mat-divider *ngIf="data.length !== (index + 1)"></mat-divider>
    </ng-container>
</mat-nav-list>
